module.exports = __webpack_public_path__ + "img/register.063a89d8.png";